
import { isObject, isArray } from './typeof'
export function allProps(obj, handler, depth, max_depth) {
    if (depth > max_depth) {
        return;
    }
    const keys = Object.keys(obj);
    keys.forEach(k => {
        const v = obj[k];
        if (isObject(v) || isArray(v)) {
            allProps(v, handler, depth + 1, max_depth);
        } else {
            handler(k, v, obj);
        }
    })
}

// const t = {
//     a: {
//         a1: 1,
//         a2: 2,
//         a3: [{
//             a31: 1,
//             a32: 2
//         }]
//     },
//     b: {
//         b1: 1,
//         b2: [
//             {
//                 b21: 1,
//                 b22: {
//                     b212: 212,
//                     b213: 213
//                 }
//             }
//         ]
//     }
// }


// allProps(t, console.log, 1, 2)
